/**
 * Utility functions for route detection and analysis
 */

/**
 * Checks if a given URL is a document details route
 * URL pattern: /:language/categories/:categoryId/documents/:documentId[/:docuLanguage]
 *
 * @param url - The URL to check
 * @returns true if the URL is a document details route, false otherwise
 */
export function isDocumentDetailsRoute(url: string): boolean {
  const urlParts = url.split('/').filter((part) => part.length > 0);
  const hasDocumentsSegment = urlParts.includes('documents');
  const hasCategoriesSegment = urlParts.includes('categories');

  // Should have at least: language, 'categories', categoryId, 'documents', documentId
  // docuLanguage is optional (6th segment)
  return hasDocumentsSegment && hasCategoriesSegment && urlParts.length >= 5;
}
